import { HEADER_TRANSLATION_KEY } from '../constants';

export default {
  en: {
    [HEADER_TRANSLATION_KEY]: {
      HEADER_ID_3_NAME: 'Resources',
      HEADER_ID_3_ITEM_1_NAME: 'Blog',
      HEADER_ID_3_ITEM_1_DESCRIPTION: 'Relevant content for your learning.',
      HEADER_ID_3_ITEM_2_NAME: 'Downloads',
      HEADER_ID_3_ITEM_2_DESCRIPTION: 'Ebooks, tools, top-cases and more.',

      HEADER_CALL_BUTTON: 'Call us',
      HEADER_FREE_TRIAL_BUTTON: 'Schedule a demo',
      HEADER_FORM_PHONE_LABEL: 'Phone number',
      HEADER_FORM_PHONE_ERROR: 'Enter a valid number',
      HEADER_FORM_PHONE_BUTTON: 'Contact us',

      HEADER_CONTACT_DIALOG_TITLE: 'Contact our team \n of experts',
      HEADER_CONTACT_DIALOG_DESCRIPTION:
        'We are available Monday to Friday from 9am to 6pm (PET)',

      HEADER_CONFIRMATION_DIALOG_TITLE:
        'Thank you for \n registering your data',
      HEADER_CONFIRMATION_DIALOG_DESCRIPTION:
        'We will be contacting you shortly \n so you can live this experience.',
      HEADER_CONFIRMATION_DIALOG_BUTTON: 'Finish',

      CLE_CTA: 'Learn more',
      CLE_TITLE: 'People Development Ecosystem',
      CLE_DESCRIPTION:
        'Before choosing a training program for your team, make sure you will have the necessary statistics to know the impact it will generate.',
    },
  },
};
